@if (breadcrumbs$ | async; as breadcrumbs) {
	@if (breadcrumbs.length > 1) {
		<ul class="breadcrumbs">
			@for (crumb of breadcrumbs; track crumb.url) {
				<li class="breadcrumbs__item">
					<a
						class="breadcrumbs__link"
						[routerLink]="crumb.url"
						[class.active]="isLinkActive(crumb.url)"
					>
						{{ crumb.displayName }}
					</a>
				</li>
			}
		</ul>
	}
}
